module.exports = __webpack_public_path__ + "img/logo-s.b1e9e7ee.png";